var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.004,
    height: 20.004,
    viewBox: "0 0 19.004 20.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Settings_icon",
    d: "M9.954,2.21a9.99,9.99,0,0,1,4.091,0,4,4,0,0,0,5.412,3.123A9.99,9.99,0,0,1,21.5,8.876a4,4,0,0,0,0,6.248,10.043,10.043,0,0,1-2.046,3.543,4,4,0,0,0-5.41,3.121,9.99,9.99,0,0,1-4.091,0,4,4,0,0,0-5.412-3.125A9.99,9.99,0,0,1,2.5,15.121a4,4,0,0,0,0-6.246A10.043,10.043,0,0,1,4.544,5.332a4,4,0,0,0,5.41-3.121ZM12,15a3,3,0,1,0-3-3A3,3,0,0,0,12,15Z",
    transform: "translate(-2.498 -1.997)",
    fill: "#31a8de"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/Settings_icon.9dc975eb222144a41192c30ada6fe082.svg";
export { ForwardRef as ReactComponent };